import React from 'react';
import { X } from 'lucide-react';

interface DsgvoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DsgvoModal: React.FC<DsgvoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-slate-900 border border-slate-700 rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-700 shrink-0">
          <h2 className="text-lg font-bold text-white tracking-wide">
            Datenschutzbestimmungen
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-lg p-2 transition-colors"
            aria-label="Schließen"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-5 text-sm text-slate-300 leading-relaxed space-y-4">
          <p>
            <strong className="text-white">1. Verantwortlicher</strong><br />
            Verantwortlich für die Datenverarbeitung im Rahmen dieser Seminaranmeldung ist PreisExpert.
            Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden.
          </p>
          <p>
            <strong className="text-white">2. Zweck der Datenverarbeitung</strong><br />
            Die von Ihnen angegebenen personenbezogenen Daten werden ausschließlich zur Bearbeitung
            Ihrer Seminaranmeldung, zur Kommunikation im Zusammenhang mit dem gebuchten Event sowie
            zur Erstellung und Abwicklung der Rechnung verwendet.
          </p>
          <p>
            <strong className="text-white">3. Rechtsgrundlage</strong><br />
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung
            bzw. vorvertragliche Maßnahmen) sowie, soweit erforderlich, Art. 6 Abs. 1 lit. a DSGVO
            (Einwilligung).
          </p>
          <p>
            <strong className="text-white">4. Speicherdauer</strong><br />
            Ihre Daten werden nur so lange gespeichert, wie dies für die Erfüllung der genannten
            Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
          </p>
          <p>
            <strong className="text-white">5. Ihre Rechte</strong><br />
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
            Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten.
            Zudem haben Sie das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
          </p>
          <p className="text-slate-500 text-xs italic">
            Hinweis: Dieser Text ist ein Platzhalter und wird durch die finalen Datenschutzbestimmungen ersetzt.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DsgvoModal;
